import React from 'react'
import { useState } from 'react'

const useShowMessage = (object = { title: '', content: <span></span>, show: false }) => {
  const [message, setMessage] = useState(object)
  return { message, setMessage }
}

export default useShowMessage
